export default function scroller(target, offset = 0) {
	const element = document.getElementById(target)
	if (!element) return

	const paddingTop = +getComputedStyle(element).paddingTop.replace(/\D+/g, '')
	const top = calculateScrollOffset(element, offset + paddingTop)

	window.scrollTo({ behavior: 'smooth', top })
}

function calculateScrollOffset(element, offset, alignment) {
	const body = document.body
	const html = document.documentElement
	const documentHeight = Math.max(
		body.offsetHeight,
		body.scrollHeight,
		html.clientHeight,
		html.offsetHeight,
		html.scrollHeight,
	)

	const scrollPosition = getScrollPosition(element, alignment)
	const maxScrollPosition = documentHeight - html.clientHeight
	return Math.min(scrollPosition + offset + window.scrollY, maxScrollPosition)
}

function getScrollPosition(element, alignment) {
	const html = document.documentElement
	const rect = element.getBoundingClientRect()

	switch (alignment) {
		case 'bottom':
			return rect.bottom - html.clientHeight
		case 'middle':
			return rect.bottom - html.clientHeight / 2 - rect.height / 2
		default:
			return rect.top
	}
}
